export const useSettings = () => {
  return {
    data: {
      currency: 'SEK',
    },
  };
};
